module.exports = "/_next/static/resources/pack-b51ce1553ec11904199d1b27cf8da517.webp";